import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('UploadOne', function (props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", null, React.createElement("g", {
    transform: "translate(4.000000, 8.000000)",
    stroke: props.outStrokeColor,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, React.createElement("path", {
    d: "M7.67771603,12.2710459 C3.27476288,13.3181203 -3.63797881e-12,17.2766292 -3.63797881e-12,22 C-3.63797881e-12,27.5228475 4.4771525,32 10,32 C10.9473815,32 11.8639929,31.8682576 12.7325136,31.6220934"
  }), React.createElement("path", {
    d: "M34.677716,12.2710459 C30.2747629,13.3181203 27,17.2766292 27,22 C27,27.5228475 31.4771525,32 37,32 L37,32 C37.9473815,32 38.8639929,31.8682576 39.7325136,31.6220934",
    transform: "translate(33.366257, 22.135523) scale(-1, 1) translate(-33.366257, -22.135523) "
  }), React.createElement("path", {
    d: "M32,12 C32,5.372583 26.627417,0 20,0 C13.372583,0 8,5.372583 8,12"
  }), React.createElement("polyline", {
    points: "13.0655651 19.8809666 20 12.9235576 27.1319641 20"
  }), React.createElement("path", {
    d: "M20,16 L20,29.5382212",
    transform: "translate(20.000000, 23.000000) scale(1, -1) translate(-20.000000, -23.000000) "
  })))));
});